/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Terms_ErrorInputs */

const en_register_onboarding_terms_error = /** @type {(inputs: Register_Onboarding_Terms_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm both consents to continue.`)
};

const de_register_onboarding_terms_error = /** @type {(inputs: Register_Onboarding_Terms_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte bestätige beide Einwilligungen, um fortzufahren.`)
};

/**
* | output |
* | --- |
* | "Please confirm both consents to continue." |
*
* @param {Register_Onboarding_Terms_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_terms_error = /** @type {((inputs?: Register_Onboarding_Terms_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Terms_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_terms_error(inputs)
	return en_register_onboarding_terms_error(inputs)
});